import { Outlet, useNavigate } from "react-router-dom";
import ProviderSidebar from "./ProviderSidebar";
import { Container, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import "./Clean.css";
import logo from "../assets/images/logos/logo.png";
import { FaUserCircle } from "react-icons/fa";
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";

const FullLayout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const toggleSidebar = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
  };

  // Logout function
  const handleLogout = () => {
    logout();
    navigate('/Login');
  };

  return (
    <main>
      {/* Full width top border */}
      <div style={{ 
        width: '100%',
        height: '4px',
        backgroundColor: '#d4d700'
      }}></div>
      {/* Full width top row with hamburger icon */}
      <div className="w-100" style={{ 
        background: 'linear-gradient(90deg, rgb(77 140 159), rgb(56 143 172))',
        zIndex: 1000,
        position: 'relative',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
      }}>
        <div className="d-flex align-items-center justify-content-between" style={{ padding: '1rem' }}>
          <div className="d-flex align-items-center">
            <Button
              color="link"
              size="sm"
              className="text-white me-3"
              onClick={toggleSidebar}
              style={{ border: 'none', padding: '0.5rem' }}
            >
              <i className="bi bi-list" style={{ fontSize: '1.5rem', color: '#fff' }}></i>
            </Button>
            <div className="d-flex align-items-center">
              <img 
                src={logo} 
                alt="Logo" 
                style={{ height: '50px', maxWidth: '250px' }}
              />
            </div>
          </div>
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle style={{ border: 'none', backgroundColor: 'transparent' }}>
              <FaUserCircle size={32} color="#fff" />
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem header>Info</DropdownItem>
              <DropdownItem>My Account</DropdownItem>
              <DropdownItem>Edit Profile</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>Invoices and Transactions</DropdownItem>
              <DropdownItem>Inbox</DropdownItem>
              <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>

      <div className="pageWrapper d-lg-flex" style={{ paddingTop: '0' }}>
        {/********Sidebar**********/}
        <aside className="sidebarArea shadow" id="sidebarArea">
          <ProviderSidebar />
        </aside>
        {/********Content Area**********/}

        <div className="contentArea">
          {/********Middle Content**********/}
          <Container className="p-4 wrapper" fluid>
            <Outlet />
          </Container>
        </div>
      </div>
    </main>
  );
};

export default FullLayout;
